import React from "react";
import { RevvForm } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

export default class MultiLineTextFieldFormMode extends React.Component {
  state = {
    multiLineTextFieldValues: {
      default: JSON.parse(JSON.stringify(this.props.initialProps.value)),
    },
  };

  _handleOnBlur = (event, value, handleBlur, isValidated) => {
    handleBlur(event);
    // If the field is validated & there is a value then only
    // make an API call and update the redux store
    if ((isValidated && value) || value === "") {
      const { id } = this.props.initialProps;
      this.props._updateDynamicFieldsInDoc(id, value);
      this._checkForUpdateField(value);
    }
  };

  _checkForUpdateField = currentValue => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue !== currentValue) {
      this.props._updateField(id, currentValue);
      if (currentValue) {
        this.props.filledStatus(true);
      } else {
        this.props.filledStatus(false);
      }
    }
  };

  render() {
    const { id /* docIsLocked */ } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.multiLineTextFieldValues}
          customFieldName="MULTI_LINE_TEXT"
          customFieldComponentRules={CustomFieldComponentRules}
          validateOnChange
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const { handleChange, handleBlur, messages, values } = formProps;
            return (
              <React.Fragment>
                <textarea
                  id={id}
                  name="default"
                  className="form-mode-input textarea"
                  // {`form-mode-input textarea ${
                  //   messages.default && messages.default.required !== ""
                  //     ? "danger-border"
                  //     : ""
                  // }`}
                  rows="10"
                  cols="30"
                  onChange={event => handleChange(event)}
                  onBlur={event =>
                    this._handleOnBlur(
                      event,
                      values.default,
                      handleBlur,
                      !messages.default,
                    )
                  }
                  value={values.default}
                  disabled={this.props.isLocked}
                  required
                  data-test="multiline-field-form-mode"
                  // eslint-disable-next-line jsx-a11y/no-autofocus
                  autoFocus
                />
                {/* <div>
                  {messages.default && (
                    <ErrorMessages messages={messages.default.required} />
                  )}
                </div> */}

                {/* <JSONPretty id="json-pretty" data={allInAll} /> */}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/MultiLineFieldFormMode.js